import { render, staticRenderFns } from "./domainDetailModal.vue?vue&type=template&id=4fa37ef3&scoped=true&"
import script from "./domainDetailModal.vue?vue&type=script&lang=js&"
export * from "./domainDetailModal.vue?vue&type=script&lang=js&"
import style0 from "./domainDetailModal.vue?vue&type=style&index=0&id=4fa37ef3&prod&lang=less&scoped=true&"
import style1 from "./domainDetailModal.vue?vue&type=style&index=1&id=4fa37ef3&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa37ef3",
  null
  
)

export default component.exports